export interface Score {
  seeds: number;
  flower: number;
}
